import registerFirstSectionAnimations from "./animations/animateFirstSection";
//______INIT______//
const init = () => {
    registerFirstSectionAnimations();
};
document.addEventListener('DOMContentLoaded', () => {
    init();
});
